export default "../css/7138222b04bb1318afb1f168640ecfc5.ttf";